import api from './api';
export default {
  generateReport: async (appId) => (await api.post(`/applications/${appId}/report`)).data,
  getReports: async (appId) => (await api.get(`/applications/${appId}/reports`)).data,
  getReport: async (id) => (await api.get(`/reports/${id}`)).data,
  getApplicantView: async (id) => (await api.get(`/reports/${id}/applicant-view`)).data,
};
